import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
  IconButton,
  IconButtonProps,
  theme,
} from '@everlywell/ui-kit';
import CardBuilder, {
  CardBuilderProps,
  ComponentNames as CardComponentNames,
} from 'components/CardBuilder';
import DynamicIcon from 'components/DynamicIcon';
import React from 'react';

export type CardsAccordionProps = {
  items: {
    button: CardBuilderProps<'InfoCardV2'>;
    content: CardBuilderProps<CardComponentNames>[];
  }[];
  buttonColorScheme?: IconButtonProps['colorScheme'];
};

type CardAccordionButtonProps = {
  isExpanded: boolean;
  colorScheme?: IconButtonProps['colorScheme'];
};

const CardAccordionButton = ({
  isExpanded,
  colorScheme = 'whiteCS',
}: CardAccordionButtonProps) => (
  <Box>
    <IconButton
      as={AccordionButton}
      aria-label={isExpanded ? 'Collapse' : 'Expand'}
      aria-expanded={isExpanded}
      icon={
        <DynamicIcon
          icon={isExpanded ? 'CaretUp' : 'CaretDown'}
          fontSize={theme.fontSizes.lg}
        />
      }
      colorScheme={colorScheme}
      width={theme.space[8]}
      height={theme.space[8]}
      size="sm"
    />
  </Box>
);

const CardsAccordion = ({ items, buttonColorScheme }: CardsAccordionProps) => (
  <Accordion allowMultiple display="flex" flexDirection="column" gap="6">
    {items.map((item, index) => (
      <AccordionItem key={index} border={0}>
        {({ isExpanded }) => (
          <>
            <Box role="heading">
              <CardBuilder
                {...item.button}
                cta={
                  <CardAccordionButton
                    isExpanded={isExpanded}
                    colorScheme={buttonColorScheme}
                  />
                }
              />
            </Box>
            <AccordionPanel
              display="flex"
              flexDirection="column"
              marginTop={4}
              gap={4}
            >
              {item.content.map(({ componentName, ...cardProps }, index) => (
                <CardBuilder
                  key={`${componentName}-${index}`}
                  componentName={componentName}
                  {...cardProps}
                />
              ))}
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    ))}
  </Accordion>
);

export default CardsAccordion;
